// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6f7495a","239":"f76f2b61","453":"db023dd4","455":"9c31a1d8"}[chunkId] + ".chunk.js";
};